import SidePanel from '@/components/TreeDoc/SidePanel.jsx'
import {useMapContext} from '@/components/MindMap/index.mjs'
import useCommentPane from '../../SidePanel/LeftPanel/CommentPane/useCommentPane.jsx'
import useExternalPane from '../../SidePanel/LeftPanel/ExternalPane/useExternalPane.jsx'
import useHiddenPane from '../../SidePanel/LeftPanel/HiddenPane/useHiddenPane.jsx'
import useImportantPane from '../../SidePanel/LeftPanel/ImportantPane/useImportantPane.jsx'
import useInvalidPane from '../../SidePanel/LeftPanel/InvalidPane/useInvalidPane.jsx'
import useMarkPane from '../../SidePanel/LeftPanel/MarkPane/useMarkPane.jsx'
import useMessagePane from '../../SidePanel/LeftPanel/MessagePane/useMessagePane.jsx'
import useSearchPane from '../../SidePanel/LeftPanel/SearchPane/useSearchPane.jsx'
import useSettingsPane from '../../SidePanel/LeftPanel/SettingsPane/useSettingsPane.jsx'
import HideIrrelevant from './ControllerHideIrrelevant.jsx'
import useUpgradeRefPane from './UpgradeRefPane/useUpgradeRefPane.jsx'

export default function LeftPanel(props) {
    const map = useMapContext()

    const panes = [
        useSearchPane(),
        useImportantPane(),
        useCommentPane(),
        useMarkPane(),
        useMessagePane(),
        useUpgradeRefPane(),
        useInvalidPane(),
        useExternalPane(),
        useHiddenPane(),
        useSettingsPane(<HideIrrelevant />),
    ]

    if (! /(ANALYSE|DEPEND|REFERENCE)_MAP$/.test(map.data.mapTypeCode)) {
        return null
    }

    return (
        <SidePanel
            direction="ltr"
            panelId="left"
            panes={panes}
            {...props}
        />
    )
}
